'use client';

import { Button } from '@pickleballinc/react-ui';
import { useRouter } from 'next/navigation';

import { GEAR_EMPTY_STATE_ALL_ILLUSTRATION } from '@/modules/players/v3/constants/gear-empty-state-illustrations';

interface MyGearEmptyStateProps {
  ctaHref: string;
  title?: string;
  description?: string;
  ctaLabel?: string;
  ctaExternal?: boolean;
  illustration?: string;
}

export const MyGearEmptyState = ({
  ctaHref,
  title = 'Explore top pickleball gear',
  description = 'Discover gear trusted by players and upgrade your game',
  ctaLabel = 'Add gear now',
  ctaExternal = false,
  illustration = GEAR_EMPTY_STATE_ALL_ILLUSTRATION,
}: MyGearEmptyStateProps) => {
  const router = useRouter();

  const ctaButton = (
    <Button
      variant='secondary'
      size='sm'
      className='rounded-md border border-gray-300'
      onClick={ctaExternal ? undefined : () => router.push(ctaHref)}
    >
      {ctaLabel}
    </Button>
  );

  return (
    <div className='relative flex min-h-[220px] w-full items-center justify-center overflow-hidden py-8'>
      <div className='z-[1] flex flex-col items-center gap-3 text-center'>
        <h4 className='max-w-[224px] text-base font-semibold text-gray-900'>{title}</h4>
        <p className='max-w-[263px] text-sm text-gray-700'>{description}</p>
        {ctaExternal ? (
          <a href={ctaHref} target='_blank' rel='noopener noreferrer'>
            {ctaButton}
          </a>
        ) : (
          ctaButton
        )}
      </div>
      <img
        src={illustration}
        alt=''
        width={200}
        height={142}
        className='pointer-events-none absolute bottom-0 left-[-27px] h-auto w-[140px] select-none object-contain object-bottom sm:left-3 sm:w-[120px] lg:w-[176px]'
      />
    </div>
  );
};
